export default "__VITE_ASSET__Ccq4ITbD__"